import pcGameDefaultIcon from '@/pages/opinion/assets/svg/pc-game-default.svg';
import mobileGameDefaultIcon from '@/pages/opinion/assets/svg/mobile-game-default.svg';
import consoleGameDefaultIcon from '@/pages/opinion/assets/svg/console-game-default.svg';
import RenderImg from '.';
import React from 'react';

export default function RenderGameIcon({
  gameInfo,
  className = '',
  imgStyle = {},
}: {
  gameInfo: {
    entity_type?: string;
    cover: string;
    edition_unified_id?: string;
  };
  className?: string;
  imgStyle?: any;
}) {
  const renderImgEle = (className: string) => {
    const defaultImages: any = {
      mobile: mobileGameDefaultIcon,
      pc: pcGameDefaultIcon,
      console: consoleGameDefaultIcon,
    };

    const defaultImage = defaultImages[gameInfo?.entity_type || 'mobile'] || '';
    return (
      <RenderImg
        className={className}
        coverImage={gameInfo?.cover}
        defaultImage={defaultImage}
        style={imgStyle}
        key={gameInfo?.edition_unified_id}
      ></RenderImg>
    );
  };

  return <>{renderImgEle(className)}</>;
}
